import { ChangeDetectionStrategy, Component, Input, signal, ViewEncapsulation } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';

import { SimpleContextMenuItem } from '../../model/simple-content-menu-item';

@Component({
  selector: 'systembar-help',
  templateUrl: './help-component.html',
  styleUrls: ['./help-component.less'],
  imports: [CelumIcon, MatMenuTrigger, MatMenu, TranslatePipe, MatMenuItem],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'systembar-help',
    '[class.celum-systembar_components--active]': 'isMenuOpen()'
  }
})
export class HelpComponent {
  @Input() public contextMenuItems: SimpleContextMenuItem[];

  public iconConfiguration = new IconConfiguration('systembar-help-colored');

  protected isMenuOpen = signal(false);
}
